import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=736ea7d1&scoped=true&"
import script from "./update-password.vue?vue&type=script&lang=ts&"
export * from "./update-password.vue?vue&type=script&lang=ts&"
import style0 from "./update-password.vue?vue&type=style&index=0&id=736ea7d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ea7d1",
  null
  
)

export default component.exports